export default __webpack_public_path__ + "static/media/Asset 6.2633c9d7.svg";